<template>
  <div
    style="text-align: right;"
  >
    <el-dropdown
      ref="dropDown"
      size="small"
      @command="handleAction"
    >
      <el-button
        size="mini"
        class="el-dropdown-link"
        @click.stop="toggleDropDown"
      >
        <i :class="!buttonLoader ? 'el-icon-more' : 'el-icon-loading'" />
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-if="customerSale.status === 'recorded'"
          v-can="'customersale.update'"
          :command="sell"
          :disabled="buttonLoader"
        >
          <i class="el-icon-check" /> Eladás lezárása
        </el-dropdown-item>
        <el-dropdown-item
          v-if="customerSale.status !== 'recorded' && customerSale.receipt_file_url"
          v-can="'customersale.view'"
          :command="openReceipt"
          :disabled="buttonLoader"
        >
          <i class="el-icon-printer" /> Bizonylat nyomtatása
        </el-dropdown-item>
        <el-dropdown-item
          v-can="'customersale.update'"
          :command="updateCustomerSale"
          :disabled="buttonLoader"
        >
          <i class="el-icon-edit" /> Módosítás
        </el-dropdown-item>
        <el-dropdown-item
          v-if="customerSale.status === 'recorded'"
          v-can="'customersale.delete'"
          :command="openDeleteConfirmation"
          :disabled="buttonLoader"
        >
          <i class="el-icon-delete" /> Törlés
        </el-dropdown-item>
        <el-dropdown-item
          :command="exportExcel"
          :disabled="buttonLoader"
        >
          <i class="el-icon-download" /> Excel exportálás
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
  export default {
    props: ['customerSale'],
    data() {
      return {
        buttonLoader: false,
        deleteConfirmVisible: false,
      };
    },

    methods: {
      async deleteCustomerSale() {
        this.buttonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('customerSale/delete', this.customerSale.id);
          this.$store.dispatch('customerSale/fetchAll');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
      async updateCustomerSale() {
        this.$router.push('/sales/customer-sales/update/' + this.customerSale.id);
      },

      async sell() {
        this.buttonLoader = true;
        try {
          await axios.post('api/customer-sales-sell/' + this.customerSale.id);
          this.$store.dispatch('customerSale/fetchAll');
        } catch (e) {
        }
        this.buttonLoader = false;
      },

      async openReceipt() {
        if (this.customerSale.receipt_file_url) {
          this.buttonLoader = true;
          try {
            const url = await axios.get('api/files?path=' + this.customerSale.receipt_file_url);
            window.open(url);
          } catch (e) {
          }
          this.buttonLoader = false;
        }
      },
      copyCustomerSale() {
        this.$router.push('/sales/customer-sales/add/' + this.customerSale.id);
      },
      openDeleteConfirmation() {
        this.$confirm('Ez a folyamat nem visszafordítható és a kapcsolódó elemek is törölve lesznek.', 'Biztosan törölni szeretnéd?', {
          confirmButtonText: 'Igen',
          cancelButtonText: 'Mégse',
          type: 'warning',
        })
        .then(() => {
          this.deleteCustomerSale();
        })
        .catch(() => {
          this.$router.replace('/sales/customer-sales');
        });
      },
      handleAction(action) {
        action();
      },
      toggleDropDown() {
        this.$refs['dropDown'].visible = !this.$refs['dropDown'].visible;
      },
      async exportExcel() {
        try {
          this.buttonLoader = true;
          const excel = await axios({
            url: 'api/customer-sales/' + this.customerSale.id + '/export',
            method: 'GET',
            responseType: 'blob',
          });
          saveAs(excel, 'customer_sale_items.xlsx');
        } catch (e) {
        }
        this.buttonLoader = false;

      },
    }
  };
</script>
